export default "__VITE_ASSET__TOgIEL8$__"